import { createSlice, configureStore } from '@reduxjs/toolkit'

export const apiSlice = createSlice({
    name: 'api',
    initialState: {
        status: 'LOADING',
        errMessage: null
    },
    reducers: {
        setSuccess: (state) => {
            state.status = 'CONNECTED'
            state.errMessage = null
        },
        setError: (state, action) => {
            state.status = 'DISCONNECTED'
            state.errMessage = action.payload.errMessage
        },
    }
})

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        role: null, // to indicate not loaded yet
    },
    reducers: {
        update: (state, action) => {
            state.user = action.payload.user
            state.role = action.payload.user?.role || 'ROLE_ANON'
        },
        clear: (state) => {
            state.user = null
            state.role = 'ROLE_ANON'
        }
    }
})

export const flashSlice = createSlice({
    name: 'flash',
    initialState: {
        lastKey: -1,
        messages: [],
    },
    reducers: {
        add: (state, action) => {
            state.lastKey += 1 // ensure a new unique key
            state.messages.push({
                key: state.lastKey, 
                type: action.payload.type,
                message: action.payload.message,
                state: 'VISIBLE'
            })
        },
        close_start: (state, action) => {
            for (var i = 0; i < state.messages.length; i++){
                if (state.messages[i].key === action.payload){
                    state.messages[i].state = 'FADING'
                    break
                }
            }
        },
        close_finish: (state, action) => {
            state.messages = state.messages.filter(message => message.key !== action.payload)
        }
    }
})

export class Store {
    static _store = configureStore({
        reducer: {
            api: apiSlice.reducer,
            auth: authSlice.reducer,
            flash: flashSlice.reducer,
        },
    })

    static getStore = () => Store._store

    static dispatch = (action) => {
        Store._store.dispatch(action)
    }
}